import * as React from "react";
import { Row, Col } from "antd";
import Title from "src/components/common/Title";

import "./documents.scss";
import { IVendaProps } from "src/services/interfaces/IVendaProps";

function DocumentsValidation(props: IVendaProps) {
  return (
    <div className="documents-validation steps-container">
      <h1>Validação de documento</h1>

      <Row
        className="info"
        type="flex"
        justify="center"
        style={{
          padding: "50px 0",
          border: "2px solid #CDCCD6",
          borderRadius: "8px",
          margin: "50px auto",
          maxWidth: "836px"
        }}
      >
        <Col>
          <Title size={"h4"} style={{ margin: 0, textAlign: "center" }}>
            Estamos analisando o documento enviado. <br />
            Este processo leva em média um dia útil.
          </Title>
        </Col>
      </Row>
    </div>
  );
}

export default DocumentsValidation;



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/documents/DocumentsValidation.tsx